// Constants and Configuration
// Fila Virtual UMA - Global constants

// Queue status values
export const STATUS = {
    WAITING: 'waiting',
    PRE_SERVING: 'pre-serving', // NEW: Optional status when host assigns (only used when store is packed)
    CALLING: 'calling',
    SERVING: 'serving',
    STANDBY: 'standby',
    DONE: 'done',
    NO_SHOW: 'no-show'
};

// Attention types
export const ATTENTION_TYPES = {
    COMPRA: 'Compra',
    CAMBIO: 'Cambio',
    OTROS: 'Otros'
};

// Time constants
export const TIME_CONSTANTS = {
    MINUTES_PER_GROUP: 12,
    DEFAULT_AVG_SERVICE_TIME: 12
};

// Phone format constants
export const PHONE_CONSTANTS = {
    PREFIX: '+569',
    MIN_LENGTH: 12,
    MAX_LENGTH: 12,
    PATTERN: /^\+569[0-9]{8}$/
};

// CSS color variables (matching :root values in index.html)
export const COLORS = {
    PRIMARY: '#82A9BA',
    PRIMARY_DARKER: '#B2C13E',
    TEXT: '#424242',
    BACKGROUND: '#F9F4E0',
    DASHBOARD_BOX: '#D6D6D6'
};

// Filter types for staff/host view
export const FILTER_TYPES = {
    WAITING: 'waiting',        // Show only waiting + calling customers
    SERVING: 'serving',        // Show only serving customers
    AFORO: 'aforo',            // Show waiting + calling + serving (all active)
    STANDBY: 'standby',        // Show standby customers
    DONE: 'done'               // Show completed customers (atendidos)
};

// View names
export const VIEWS = {
    LOGIN: 'login',
    REGISTER: 'register',
    WAITING: 'waiting',
    STAFF: 'staff',
    HOST: 'host', // NEW: Host view for queue management
    SURVEY: 'survey',
    TOKEN_ERROR: 'tokenError'
};

// User roles (Phase 2)
export const ROLES = {
    SELLER: 'seller',
    HOST: 'host',
    ADMIN: 'admin'
};

// Seller availability status (for host view)
export const SELLER_STATUS = {
    AVAILABLE: 'available',  // Green: Online, not paused, not serving
    BUSY: 'busy',            // Red: Currently serving a customer
    PAUSED: 'paused',        // Yellow: On break
    OFFLINE: 'offline'       // Grey: Not online
};

// Host view color scheme (user-specified)
export const HOST_COLORS = {
    AVAILABLE: '#10B981',    // Green
    BUSY: '#EF4444',         // Red
    PAUSED: '#F59E0B',       // Yellow/Amber
    OFFLINE: '#6B7280'       // Grey
};
